import React, { useState } from 'react';
import blog1 from '../../../assets/images/developers-working-on-desktop.avif';
import blog2Img2 from '../../../assets/images/a-small-business-shop.avif';
import { FaArrowRight } from "react-icons/fa6";
import { Link } from 'react-router-dom';
import { routes } from '../../../config/utilities/utils.constant';

const blogData = [ 
 
    {
      image: blog2Img2,
      alt:'A small furniture business shop having their web address displayed on the shop.',
      title: "Websites for Small Businesses",
      desc: "If there’s one lesson the past few years have taught small businesses, it’s that an online presence isn’t optional anymore; it’s essential. During the COVID-19 pandemic, countless small businesses survived, and even thrived, by shifting operations online. From curbside pickup coordinated through simple websites to service-based businesses offering virtual consultations, being online turned out to be a lifesaver.",
      descriptionPageLink:  routes.BLOG2,
      date: "May 2, 2025",
      time: "4",
      ariaLabel :"Internal link to website services for small businesses"
    },
       {
      image: blog1,
      alt:'Developers working on their desktop PCs in office, with code displayed on their screens.',
      title: "Welcome to our new site Apptalyst.com! ",
      desc: "We’re thrilled to introduce Apptalyst.com, your new go-to for high-performance digital solutions. Our website is built to be fast, sleek, and just as friendly as we are.",
      date: "April 3, 2025",
      descriptionPageLink:  routes.BLOG1,
      time: "3",
      ariaLabel :"Internal link to learn more about our new website"

    },
   
   
  ];
  
function BlogCards() {
  const [page, setPage] = useState(1);
  const itemsPerPage = 4;

  const handlePageChange = (event, value) => {
    setPage(value);
  };

  const paginatedBlogs = blogData.slice((page - 1) * itemsPerPage, page * itemsPerPage);

  return (
    < >
      <div className='grid grid-cols-1 md:grid-cols-2 gap-10 xl:gap-x-20 gap-y-10  px-5'>
        {paginatedBlogs.map((blog, index) => (
          <article  key={index} className='w-[100%] flex flex-col h-full rounded-3xl overflow-hidden shadow-xl'>
            <div>
              <Link to={blog.descriptionPageLink} aria-label={blog.ariaLabel}>
              <img src={blog.image} alt={blog.alt} className='object-cover w-full h-80'  />
              </Link>
            </div>
            <div className='px-4 md:px-8 py-5 space-y-5   flex flex-col justify-between flex-grow '>
              <div>
               <Link to={blog.descriptionPageLink} aria-label={blog.ariaLabel}> <h2 className='text-xl md:text-2xl font-bold pb-2 text-dark'> {blog.title}</h2></Link>
                <p className='text-base leading-[1.625rem]  line-clamp-3 text-dark'>{blog.desc}</p>
              </div>
              <div className='flex  justify-between nd:items-center text-xs border-t border-[#F7F7F7] pt-3 align-bottom'>
                <div className='pr-4 border-r border-[#CECECE] text-sm capitalize  text-dark flex flex-wrap flexcol lgflex-row '>
               <div className='flex-1'>   {blog.date} </div>
               {/* <div>{blog.date.split(',')[1]}</div> */}
                </div>
                <div className='flex-grow pl-4 flex justify-end text-[#6D1349] font-bold space-x-4'>
                  {/* <div className=''>{blog.time}</d */}
                  <div className=''>{blog.time} minutes read</div>
                  <div>    <Link to={blog.descriptionPageLink} aria-label={blog.ariaLabel}> <FaArrowRight className='text-[#6D1349] text-base md:text-xl' /></Link> </div>
                </div>
              </div>
            </div>
          </article >
        ))}
      </div>

      {/* Pagination */} 
      {/* <Box className='mt-10 flex justify-center'>
        <Pagination
          count={Math.ceil(blogData.length / itemsPerPage)}
          page={page}
          onChange={handlePageChange}
          color="primary"
          shape="rounded"
        />
      </Box> */}
    </>
  );
}

export default BlogCards;
